import * as moment from 'moment-timezone';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DetailsFormModel } from './details.model';

export default class DetailsForm {
  private formBuilder: FormBuilder;
  public formGroup: FormGroup;
  public model: DetailsFormModel;

  constructor(model: DetailsFormModel) {
    this.formBuilder = new FormBuilder();
    this.model = model;
    this.createForm();
  }

  // Create form fields with validation rules
  public createForm() {
    this.formGroup = this.formBuilder.group({
      firstName: new FormControl(this.model.firstName, { validators: [Validators.required], updateOn: 'blur'}),
      lastName: new FormControl(this.model.lastName, { validators: [Validators.required], updateOn: 'blur'}),
      email: new FormControl(this.model.email, { validators: [Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')], updateOn: 'blur'}),
      date: new FormControl(this.model.birthday, { validators: [Validators.required]}),
      phone: new FormControl(this.model.phone, { validators: [Validators.required, Validators.pattern(/[0-9\+\-\ ]/)], updateOn: 'blur'}),
      permission: new FormControl(this.model.receiveSpecialOfferEmail),
      password: new FormControl(this.model.plain_password, { validators: [Validators.required, Validators.minLength(5)], updateOn: 'blur'}),
      passwordConfirm: new FormControl(this.model.passwordConfirm, { validators: [Validators.required], updateOn: 'blur'})
    });

    // form update
    this.formGroup.valueChanges.subscribe(data => {
      this.model.firstName = data.firstName;
      this.model.lastName = data.lastName;
      this.model.email = data.email;
      this.model.phone = data.phone;
      if (data.date && data.date.year) {
        this.model.birthday = moment(new Date(data.date.year, data.date.month - 1, data.date.day, 0, 0, 0, 0)).format();
      } else {
        this.model.birthday = data.date;
      }
      this.model.plain_password = data.password;
      this.model.receiveSpecialOfferEmail = data.permission;
      this.model.receiveSpecialOfferSms = data.permission;
      this.model.receiveSpecialOfferPush = data.permission;
    });
  }

  // get form property name
  public getControl(name: string) {
    return this.formGroup.get(name);
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/details/details.form.ts